import { LanguageService } from './languageService';

const languageService = new LanguageService();

export { languageService };
